import { render, staticRenderFns } from "./FontsEdit.vue?vue&type=template&id=414688a8&"
import script from "./FontsEdit.vue?vue&type=script&lang=js&"
export * from "./FontsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports